export { default } from './QuillEditor.vue'
